const {
	getRequest,
	postRequest,
	putRequest,
	deleteRequest,
} = require("./http-helper");
const api = "configurations";

const createConfiguration = ({ name, description, value, type }) => {
	return new Promise((resolve, reject) => {
		postRequest(api, { name, description, value, type }, resolve, reject, true);
	});
};

const deleteConfiguration = (id) => {
	return new Promise((resolve, reject) => {
		deleteRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getConfigurationDetails = (id) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/${id}`, resolve, reject, true);
	});
};

const getConfigurationDetailsByName = (name) => {
	return new Promise((resolve, reject) => {
		getRequest(`${api}/filtered?name=${name}`, resolve, reject, true);
	});
};

const getConfigurations = (institutional = false) => {
	return new Promise((resolve, reject) => {
		getRequest(
			`${api}${institutional ? "/institutional" : ""}`,
			resolve,
			reject,
			true
		);
	});
};

const updateConfiguration = ({ _id, name, description, value, type }) => {
	return new Promise((resolve, reject) => {
		putRequest(
			`${api}/${_id}`,
			{ name, description, value, type },
			resolve,
			reject,
			true
		);
	});
};

module.exports = {
	createConfiguration,
	deleteConfiguration,
	getConfigurationDetails,
	getConfigurations,
	updateConfiguration,
	getConfigurationDetailsByName,
};
